import React, {useState} from 'react';
import RedesignAddPaymentMethodSetup from "../RedesignAddPaymentMethodSetup";

const AddPaymentMethodSetup = (props) => {
  const {
    account,
    onClose,
    loadPaymentMethods,
    open,
    ref,
    onOpen,
  } = props;

  const [microDepositVerify, setMicroDepositVerify] = useState(false);
  const [payWithAch, setPayWithAch] = useState(false);
  const [collectMicroDepositVerifyPayment, setCollectMicroDepositVerifyPayment] = useState(false);

  const setAchHandler = (bool) => {
    setPayWithAch(bool);
    setMicroDepositVerify(false);
    setCollectMicroDepositVerifyPayment(false);
  }

  return <RedesignAddPaymentMethodSetup
    account={account}
    collectMicroDepositVerifyPayment={collectMicroDepositVerifyPayment}
    doneWithAddPaymentMethod={onClose}
    loadPaymentMethods={loadPaymentMethods}
    microDepositVerify={microDepositVerify}
    payWithAch={payWithAch}
    paymentModalOpen={open}
    ref={ref}
    setACH={setAchHandler}
    setMicroDeposit={setCollectMicroDepositVerifyPayment}
    setPaymentModalOpen={onOpen}
  />
};

export default AddPaymentMethodSetup;